import React from "react";
import List from "@material-ui/core/List/List";
import i18n from "../../i18n";
import Item from './Item';

const Back = ({ onClick }) => (
    <List>
        <Item
            onClick={onClick}
            text={i18n.get('default.nav.back')}
            icon="chevron_left"
        />
    </List>
);

export default Back;


// WEBPACK FOOTER //
// ./resources/assets/js/components/Drawer/Back.jsx